<template>
    <div class="section-tab-content media-tab-item" v-if="!loading">
        <!-- Если нет рубрик, то в контейнер  'section-tab-content' надо вставить контент для одной вкладки -->
        <div v-show="slides && slides.length > 0" style="margin: 0 auto;position: relative;list-style: none;padding: 0;z-index: 1;">
            <swiper v-show="preloader" class="top-video video-swiper"
                    :options="swiperOption"
                    ref="mediaTabSwiper"
                    @slideChange="slideEvent"
                    id="mediaTabSwiper">
                <!-- slides -->
                <swiper-slide v-for="slide in slides" :key="slide.id">
                    <div class="teaser">
                        <router-link :to="{ name : 'movie-info', params: { id : slide.id}}">
                            <img :data-src="media + 'sliders/' + slide.image" src="../assets/images/preloader1228x492.gif" class="swiper-lazy" width="1228" height="492" :alt="slide.title">
                            <img :data-src="media + 'sliders/' +  slide.mobileImage" src="../assets/images/preloader350x534.gif" class="swiper-lazy mob" width="350" height="534" :alt="slide.title">
                        </router-link>
                        <div class="content-item__info">
                            <div class="content-item__title"><h3>{{slide.title}}</h3></div>
                            <div class="content-item__lang"><i class="svg-inline headphones-icon"></i><span>{{slide.lang}}</span></div>
                            <div class="content-item__platforms"><i class="svg-inline plane-icon"></i><span>{{$t('avaiable')}}:  {{slide.airplane}}</span></div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </div>


        <ul v-if="items" class="items-list">
            <li v-for="item in items" :key="item.id">
                <div class="teaser">
                    <router-link :to="{ name : options.link, params: { id : item.id || '1' }}">
                        <img v-lazy="{
                                src: media + 'covers/' + item.image,
                                loading: options.preloaderImage,
                                error: options.preloaderImage,
                            }" :width="options.width" :height="options.height" :alt="item.title">
                    </router-link>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import image1 from "../assets/images/preloader178x272.png"
    import image2 from "../assets/images/preloader283x283.png"
    import image3 from "../assets/images/preloader283x207.png"

    const imgParameters = {
        movies: { width: '178', height: '272', link: 'movie-info', preloaderImage: image1 },
        kids:   { width: '178', height: '272', link: 'movie-info', preloaderImage: image1 },
        tv:     { width: '178', height: '272', link: 'movie-info', preloaderImage: image1 },
        music:  { width: '283', height: '283', link: 'music-info', preloaderImage: image2 },
        games:  { width: '283', height: '207', link: 'game-info' , preloaderImage: image3 },
    };
    import { mapGetters } from 'vuex'
    export default {
        name: "MediaTab",
        props:['category'],
        data(){
            return {
                slides: false,
                loading: true,
                items: false,
                preloader: false,
                media: process.env.VUE_APP_MEDIA,
                swiperOption:{
                    centeredSlides: true,
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 32,
                    preloadImages: false,
                    lazy: true,
                    loadPrevNext: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
            }
        },
        computed:{
            ...mapGetters({
                lang: 'getLang',
                preview: 'getPreview',
            }),
            options() {
                return imgParameters[this.$route.name]
            },
            mySwiper(){
                return this.$refs.mediaTabSwiper.swiper
            },
        },
        watch: {
            lang: function (oldVal, newVal) {
                if(newVal){
                    this.getContent();
                }
            },
        },
        created(){
            this.getContent();
        },
        methods:{
            getContent(){
                this.loading = true;
                this.axios.get(this.lang + '/category?menu='+ this.$route.name + '&title=' + this.category + (this.preview ? ('&set=' + this.preview) : ''))
                    .then(response => {
                        if(response.data.data.slides) {
                            this.slides = response.data.data.slides;
                        }
                        this.items = response.data.data.items;
                        this.loading = false;
                        this.$nextTick(() => {
                            let img = window.document.querySelector('.preloader-desktop');
                            if( screen.width < 600 ) {
                                img = window.document.querySelector('.preloader-mobile');
                            }
                            img.addEventListener("load", (e) => {
                                console.log(e);
                                this.preloader = true;
                            } );
                            if (img.complete) {
                                this.preloader = true;
                            }
                            window.dispatchEvent(new Event('resize'));
                        });

                    })
                    .catch(error =>{
                        console.log(error, error.response);
                        this.loading = false;
                    })
            },
            slideEvent(){
                this.mySwiper.lazy.loadInSlide(+(this.mySwiper.activeIndex) + 1 );
            },
        },
    }
</script>

<style scoped>

</style>